import { InformationCircleIcon } from '@heroicons/react/24/outline';
import type { VacationIneligibilityReason } from '../../../models/vacation.types';
import type { VacationStage } from '../../../utils/vacationEligibility';
import {
    INELIGIBILITY_MESSAGES,
    TOO_EARLY_BLOCK_HINT,
    TOO_EARLY_BLOCK_MESSAGE,
    UNKNOWN_BALANCE_BLOCK_HINT,
    UNKNOWN_BALANCE_BLOCK_MESSAGE,
    UP_TO_DATE_BLOCK_MESSAGE,
    buildUpToDateBlockHint,
} from '../vacationRequestPage.definitions';

export interface FormLockedNoticeProps {
    stage: Extract<VacationStage, 'tooEarly' | 'ineligible' | 'unknown'> | 'upToDate';
    ineligibilityReason?: VacationIneligibilityReason | null;
    nextEntitlementDate?: string | null;
}

export function FormLockedNotice({ stage, ineligibilityReason, nextEntitlementDate }: FormLockedNoticeProps) {
    let message = '';
    let hint = '';

    if (stage === 'ineligible' && ineligibilityReason) {
        message = INELIGIBILITY_MESSAGES[ineligibilityReason];
    } else if (stage === 'tooEarly') {
        message = TOO_EARLY_BLOCK_MESSAGE;
        hint = TOO_EARLY_BLOCK_HINT;
    } else if (stage === 'unknown') {
        message = UNKNOWN_BALANCE_BLOCK_MESSAGE;
        hint = UNKNOWN_BALANCE_BLOCK_HINT;
    } else if (stage === 'upToDate') {
        message = UP_TO_DATE_BLOCK_MESSAGE;
        hint = buildUpToDateBlockHint(nextEntitlementDate ?? null);
    }

    return (
        <div className="flex gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4">
            <InformationCircleIcon className="h-5 w-5 shrink-0 text-amber-600 mt-0.5" aria-hidden="true" />
            <div>
                <p className="text-sm font-medium text-amber-900 font-montserrat">{message}</p>
                {hint && <p className="mt-1 text-xs text-amber-800 font-montserrat">{hint}</p>}
            </div>
        </div>
    );
}

export default FormLockedNotice;
